import appsettings from '../../config/appsettings.json';

import { env } from '../../config/env';

//Remember to edit this based of the environment
const { clientId, authority, baseApiUrl, baseAppUrl, timeout } =
	appsettings[env];

export const _clientSettings = {
	clientId: clientId,
	authority: authority,
	baseApiUrl: baseApiUrl,
	baseAppUrl: baseAppUrl,
	timeout: timeout,
};
